// Telemetry first: Sentry + PostHog init runs on import, before anything renders.
import './lib/telemetry'
import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import {MutationCache, QueryCache, QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {isAxiosError} from 'axios'
import './index.css'
import './i18n'
import {manejarErrorDeMutacion} from './lib/red-errores-mutacion'
import {anotarLecturaFallida} from './lib/red-errores-lectura'
import {ErrorBoundary} from './components/error-boundary'
import App from './App.tsx'

const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => manejarErrorDeMutacion(error, mutation),
  }),
  // Las lecturas solo se anotan: cada pantalla decide cómo pintar su error.
  queryCache: new QueryCache({onError: anotarLecturaFallida}),
  defaultOptions: {
    queries: {
      // Un 4xx es definitivo; solo se reintentan las fallas de red y los 5xx.
      retry: (failureCount, error) => {
        if (isAxiosError(error) && error.response && error.response.status < 500) return false
        return failureCount < 2
      },
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* Fuera del QueryClientProvider: si explota el provider, la pantalla de error sigue en pie. */}
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>
)
